import React from 'react';
import { observer } from 'mobx-react';
import { signatureContainer } from 'src/signature/ioc';
import { VisitAssistantSidebarMobile } from './visit-assistant-sidebar-mobile';
import { VisitAssistantSidebarDesktop } from './visit-assistant-sidebar-desktop';
import { SignatureStore } from 'src/signature/stores/signature.store';

export interface VisitAssistantSidebarComponentProps {
    estimateLink: string | null;
    payInvoiceLink: string | null;
}

export interface SidebarButtonComponentProps {
    backgroundImageClassName: string;
    title: string;
    link: string;
}

export const VisitAssistantSidebar: React.FC = observer(() => {
    const { estimateBundleId } = signatureContainer.get(SignatureStore)!;

    const estimateLink = estimateBundleId ? `/estimate/${estimateBundleId}` : null;
    const payInvoiceLink = null;
    return (
        <VisitAssistantSidebarDesktop estimateLink={estimateLink} payInvoiceLink={payInvoiceLink} />
    );
});
